/* SessionStatusIcon.tsx generated by @compiled/babel-plugin v2.0.0 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0hPCNLDIqT%7Balign-items%3Acenter%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3YEZNOdnbC%7Bflex-shrink%3A0%7D");
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._1VJPcayz1h%7Btransform%3AscaleX(-1)%7D");
import React from 'react';
type SessionStatusIconStatus = 'needs-input';
type SessionStatusIconProps = {
  status: SessionStatusIconStatus;
  label?: string;
  color?: string;
  testId?: string;
};
const styles = {
  icon: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC _1VJPcayz1h"
};
const NeedsInputIcon = ({
  label,
  color,
  testId
}: Omit<SessionStatusIconProps, 'status'>): React.JSX.Element => <svg aria-label={label || undefined} role={label ? 'img' : 'presentation'} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-testid={testId}>
		<path fill={color} fillRule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8M7.25 1.5H8a6.5 6.5 0 0 1 0 13h-.75z" clipRule="evenodd" />
	</svg>;
export const SessionStatusIcon = ({
  status,
  label = '',
  color = "var(--ds-icon-discovery, #AF59E1)",
  testId
}: SessionStatusIconProps): React.JSX.Element | null => {
  if (status === 'needs-input') {
    return <span data-testid={testId} className={ax([styles.icon])}>
				<NeedsInputIcon label={label} color={color} />
			</span>;
  }
  return null;
};